import React, { useEffect, useState } from "react";
import minesbg from "../../Assets/Mines/minebg1.png";
import coinbox from "../../Assets/Mines/coinbox.png";
import miner from "../../Assets/Mines/Miner.png";
import chip1 from "../../Assets/Mines/Chips/10 CHIPS.png";
import chip2 from "../../Assets/Mines/Chips/50 CHIPS.png";
import chip3 from "../../Assets/Mines/Chips/100 CHIPS.png";
import chip4 from "../../Assets/Mines/Chips/250 CHIPS.png";
import chip5 from "../../Assets/Mines/Chips/500 CHIPS.png";
import chip6 from "../../Assets/Mines/Chips/1000 CHIPS.png";

import coinSound from "../../Assets/Mines/Coin.wav";
import bompexplosion from "../../Assets/Mines/BombExplosion.wav";
import buttonclick from "../../Assets/Mines/ButtonClick.mp3";
import PlaceBetSound from "../../Assets/Mines/PlaceBetSound.wav";
import AlertSound from "../../Assets/Mines/AlertSound.wav";

import toggleon from "../../Assets/Mines/toggleon.png";
import toggleoff from "../../Assets/Mines/toggleoff.png";
import { CiPlay1 } from "react-icons/ci";
import {
  ApplyMinesBet,
  DoMineCahsout,
  getMinesOptionList,
} from "./MinesEndpoint";
import { message, Select, Spin } from "antd";
import { useMediaQuery } from "react-responsive";
import { getProfile, getWallletBalance } from "../Profile/UserEndpoints";
import { useNavigate } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import { useCommmonStore } from "../../Store/CommonReducer";

const Mines = () => {
  const [amount, setAmount] = useState(10);
  const [betId, setBetId] = useState(null);
  const [gameOption, setGameOption] = useState(1);
  const [gameOptionList, setGameOptionList] = useState([]);
  const [isLandscape, setIsLandscape] = useState(false);
  const [maxCoinShow, setMaxCoinShow] = useState([]);
  const [counter, setCounter] = useState(0);
  const [showGridBg, setShowGridBg] = useState(true);
  const isSmallScreen = useMediaQuery({ minWidth: 200, maxWidth: 767 });
  const [walletBalance, setWalletBalance] = useState(0);
  const [isAllowed, setIsAllowed] = useState(true);
  const [selectedColumn, setSelectedColumn] = useState(null);
  const { profileDetail, setProfileDetail } = useCommmonStore();

  const [blockGrid, setBlockGrid] = useState(
    Array.from({ length: 25 }, (_, index) => ({
      id: index + 1,
      bomb: false,
      coin: false,
      showCoinGif: false,
      showBombGif: false,
    }))
  );
  const [bombCount, setBombCount] = useState(4);
  const navigate = useNavigate();

  const getMinesOption = () => {
    getMinesOptionList(`?game_option=${gameOption}`)
      .then((res) => {
        if (res.status) {
          setGameOptionList(res.data.multipication_sequense);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleApplyBet = () => {
    const audio = new Audio(PlaceBetSound);
    audio.play();
    ApplyMinesBet({ amount, betType: gameOption })
      .then((res) => {
        if (res.status) {
          setMaxCoinShow(res.loc);
          // setMaxCoinShow([1, 2, 3,4,5]);
          setBetId(res.betId);
          getMinesOption();
          UserProfile();
        }
      })
      .catch((err) => console.log(err));
  };

  const UserProfile = () => {
    getProfile()
      .then((res) => {
        if (res.status) {
          setProfileDetail(res.data);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    // GetRoomDetails();
    UserProfile();
  }, []);

  const handleCashOut = () => {
    DoMineCahsout({
      betId,
      multipicationNumberRange: gameOptionList.slice(0, counter),
    })
      .then((res) => {
        if (res.status) {
          const audio = new Audio(AlertSound);
          audio.play();
          message.success(res.message, 3);
          setTimeout(() => {
            let temp = [...blockGrid];
            temp = temp.map((i) => {
              return {
                ...i,
                showBombGif: false,
                bomb: false,
                coin: false,
                showCoinGif: false,
              };
            });
            UserProfile();
            setBlockGrid(temp);
            getMinesOption();
            setBetId(null);
            setMaxCoinShow([]);
            setCounter(0);
            setAmount(10);
            setSelectedColumn(null);
            setShowGridBg(true);
          }, 1000);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleClick = (index) => {
    setIsAllowed(false);

    if (isAllowed) {
      setSelectedColumn(index);
      if (maxCoinShow?.includes("bomb")) {
        let temp = [...blockGrid];

        // Update the selected index to show the bomb gif
        temp[index] = { ...temp[index], showBombGif: true };

        setBlockGrid(temp);
      } else {
        setCounter(counter + 1);
      }
    }
  };

  useEffect(() => {
    let temp = [...blockGrid];
    if (selectedColumn) {
      if (counter > maxCoinShow?.length) {
        temp[selectedColumn] = {
          ...temp[selectedColumn],
          showBombGif: true,
          showCoinGif: false,
          coin: false,
        };
      } else {
        temp[selectedColumn] = { ...temp[selectedColumn], showCoinGif: true };
      }
    }
    setBlockGrid(temp);
  }, [counter]);

  // useEffect(() => {
  //   const checkOrientation = () => {
  //     setIsLandscape(window.matchMedia("(orientation: landscape)").matches);
  //   };
  //   checkOrientation();
  //   window.addEventListener("resize", checkOrientation);
  //   window.scrollTo(0, 1); // Slight scroll to hide toolbar
  //   // Cleanup listener on component unmount
  //   return () => window.removeEventListener("resize", checkOrientation);
  // }, []);
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: landscape)");

    const handler = (e) => {
      setIsLandscape(e.matches);
    };

    setIsLandscape(mediaQuery.matches);
    mediaQuery.addEventListener("change", handler);

    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, []);

  const handleClickRandom = () => {
    setIsAllowed(false);
    if (isAllowed) {
      const min = 0;
      const max = 24;
      const blockedNumbers = blockGrid?.map((i, index) => {
        if (i.bomb || i.coin) {
          return index;
        }
      });
      let number;
      do {
        number = Math.floor(Math.random() * (max - min + 1)) + min;
      } while (blockedNumbers.includes(number)); // Keep generating if it's the blocked number
      setSelectedColumn(number);
      if (maxCoinShow?.includes("bomb")) {
        let temp = [...blockGrid];

        // Update the selected index to show the bomb gif
        temp[number] = { ...temp[number], showBombGif: true };

        setBlockGrid(temp);
      } else {
        setCounter(counter + 1);
      }
    }
  };

  useEffect(() => {
    let interval;
    let count = 4;
    if (selectedColumn !== null) {
      interval = setInterval(() => {
        count += 1;
        setBombCount(count);
        if (count >= 31) {
          setIsAllowed(true);
          clearInterval(interval);

          if (maxCoinShow?.includes("bomb")) {
            let temp = [...blockGrid];
            temp = temp.map((item, index1) => {
              if (index1 !== selectedColumn) {
                return { ...item, coin: true };
              }
              return { ...item, showBombGif: false, bomb: true };
            });
            setShowGridBg(false);
            setBlockGrid(temp);
            setTimeout(() => {
              let temp = [...blockGrid];
              temp = temp.map((i) => {
                return { ...i, showBombGif: false, bomb: false, coin: false };
              });
              getMinesOption();
              setBlockGrid(temp);
              setBetId(null);
              setMaxCoinShow([]);
              setCounter(0);
              setAmount(10);
              setSelectedColumn(null);
              setShowGridBg(true);
            }, 2000);
            const audio = new Audio(bompexplosion);
            audio.play();
          } else {
            let temp = [...blockGrid];
            if (counter > maxCoinShow?.length) {
              temp = temp.map((item, index1) => {
                if (index1 !== selectedColumn) {
                  return { ...item, coin: true };
                }
                return { ...item, showBombGif: false, bomb: true };
              });
              setShowGridBg(false);

              setTimeout(() => {
                let temp = [...blockGrid];
                temp = temp.map((i) => {
                  return {
                    ...i,
                    showBombGif: false,
                    bomb: false,
                    coin: false,
                    showCoinGif: false,
                  };
                });
                getMinesOption();
                setBlockGrid(temp);
                setBetId(null);
                setMaxCoinShow([]);
                setCounter(0);
                setAmount(10);
                setSelectedColumn(null);
                setShowGridBg(true);
              }, 2000);
              const audio = new Audio(bompexplosion);
              audio.play();
            } else {
              temp[selectedColumn] = {
                ...temp[selectedColumn],
                showCoinGif: false,
                coin: true,
              };
              const audio = new Audio(coinSound);
              audio.play();
            }
            setBlockGrid(temp);
          }
        }
      }, 50);
    }
  }, [selectedColumn]);
  return (
    <>
      {isSmallScreen && !isLandscape ? (
        <div className=" font-semibold bg-black text-yellow-500 flex justify-center h-screen text-xl font-inter animate-lightThunder items-center">
          <p>Please Rotate Your Device</p>
        </div>
      ) : (
        <div
          style={{ backgroundImage: `url(${minesbg})` }}
          className="h-screen min-h-screen select-none  bg-[#160225] relative  flex flex-col justify-center items-center w-full bg-no-repeat bg-cover bg-center"
        >
          <div
            style={{ zIndex: 1 }}
            className="flex justify-start items-center gap-6 absolute top-8 left-12"
          >
            <TiArrowBack
              onClick={() => navigate(-1)}
              color="yellow"
              className="border-2 w-12 h-12 bg-yellow-600 cursor-pointer border-yellow-500 rounded-md p-3"
              size={25}
            />
          </div>
          <div className="bg-[#00000094] relative rounded-2xl w-[95%] h-[95%] flex justify-center items-center flex-col m-auto">
            <div className=" bg-[#4B2E8E] flex justify-between items-center p-1 mt-5 rounded-full px-2 w-3/4 md:w-[60%]">
              <div>
                <Select
                  value={"Mines"}
                  onChange={(val) => setGameOption(val)}
                  placeholder="Mines"
                  className="w-32 h-6 text-center rounded-full mine-selector text-black"
                  options={[
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20,
                  ].map((i) => {
                    return {
                      label: i,
                      value: i,
                    };
                  })}
                />
              </div>
              <div className="text-xs text-white">
                <p>₹ {profileDetail?.user?.wallet_balance ?? 0}</p>
              </div>
            </div>
            <div className="flex mt-3 justify-around  relative items-start w-3/4 md:w-[55%] lg:w-3/4 xl:w-1/2  gap-x-3">
              <div className="gridarea w-[40%] md:w-[55%]">
                <div className="grid grid-cols-5  place-items-center gap-2  m-auto">
                  {blockGrid?.map((i, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {
                          if (
                            betId &&
                            !i.coin &&
                            !i.bomb &&
                            !i.showBombGif &&
                            !i.showCoinGif
                          ) {
                            handleClick(index);
                          }
                        }}
                        style={{
                          background:
                            showGridBg &&
                            "linear-gradient(136.62deg, #5A33B6 2.67%, #BA9DFF 100%)",
                          boxshadow: "4px 4px 4px 0px #00000040",
                        }}
                        className=" rounded-md  cursor-pointer  w-8 h-8 m-auto lg:w-16 lg:h-16 xl:w-16 xl:h-16 2xl:w-24 2xl:h-24"
                      >
                        {i?.showBombGif && (
                          <img
                            src={`/Bomb/Bomb${bombCount}.png`}
                            alt="Bomb"
                            className="flex justify-center items-center"
                          />
                        )}
                        {i?.showCoinGif && (
                          <img
                            src={`/Coin/Coin${bombCount - 3}.png`}
                            alt="Bomb"
                            className="flex justify-center items-center"
                          />
                        )}
                        {i?.bomb && (
                          <img
                            src={`/Mine.png`}
                            alt="Bomb"
                            className="flex justify-center items-center"
                          />
                        )}
                        {i?.coin && (
                          <img
                            src={`/Coin.png`}
                            alt="Bomb"
                            className="flex justify-center w-3/4 m-auto mt-2 items-center"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="betarea text-start w-[60%] md:w-[45%]  text-white">
                <div className="flex justify-around items-center text-xs  gap-x-5 w-[95%]">
                  <div className="bg-[#381982] cursor-pointer w-full text-start font-semibold rounded-lg font-inter p-1 xl:p-2">
                    <p className="flex justify-between items-center">
                      Mines <span>{gameOption}</span>
                    </p>
                  </div>
                  <div
                    style={{
                      background:
                        "radial-gradient(50% 50% at 50% 50%, #FF0000 0%, #A21A0A 100%)",
                    }}
                    className=" w-full text-start cursor-pointer font-semibold rounded-lg font-inter p-1 xl:p-2"
                  >
                    <p className="flex justify-between items-center">
                      Next{" "}
                      <span>
                        {betId &&
                          gameOptionList[counter] &&
                          `${gameOptionList[counter]} X`}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="grid grid-cols-2 place-items-start mt-4  gap-3 w-1/4 md:w-1/2">
                  {[
                    [chip1, 10],
                    [chip2, 50],
                    [chip3, 100],
                    [chip4, 250],
                    [chip5, 500],
                    [chip6, 1000],
                  ]?.map((i, index) => {
                    return (
                      <img
                        key={index}
                        src={i[0]}
                        onClick={() => {
                          setAmount(i[1]);
                          const audio = new Audio(buttonclick);
                          audio.play();
                        }}
                        alt="10chips"
                        className="cursor-pointer  w-[92%] md:w-[82%] lg:w-[80%] xl:w-full"
                      />
                    );
                  })}
                </div>
                <div className="flex absolute justify-around items-center text-xs  gap-x-5 w-[49%] md:w-[25%] bottom-0 mt-3 lg:mt-8">
                  <div
                    onClick={betId ? handleClickRandom : () => {}}
                    className="bg-[#AE1709] w-full cursor-pointer text-center font-semibold rounded-lg font-inter p-1 xl:p-2"
                  >
                    <p>Random</p>
                  </div>
                  {/* <div className="bg-[#7349D4] gap-x-3 w-full text-start flex justify-start items-center font-semibold rounded-lg font-inter p-1 xl:p-2">
                    <img
                      src={toggleon}
                      alt="toggleon"
                      className="cursor-pointer w-[15%]"
                    />
                    <p>Auto Game</p>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="flex justify-around items-center w-3/4 lg:w-3/4 xl:w-1/2 mt-3 md:mt-8 gap-x-3">
              <div
                style={{ zIndex: 1 }}
                className="bet-bar w-[55%] text-xs text-white font-inter  bg-[#4B2E8E] rounded-full"
              >
                <div className="flex justify-around items-center bg-[#5A33B6] m-1 md:m-2 py-[6px]   rounded-full">
                  <div className="flex gap-x-3 justify-center items-center">
                    <p>Bet</p>
                    <input
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      onInput={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        e.target.value = value;
                      }}
                      className="bg-[#4B2E8E] rounded-full h-5  py-1 text-xs outline-none text-center border-none"
                    />
                  </div>
                  <p
                    onClick={() => {
                      if (amount > 1) {
                        setAmount(amount - 1);
                      }
                    }}
                    className="bg-[#7349D4] text-white cursor-pointer shadow-2xl w-4 h-4 border rounded-md flex justify-center items-center shadow-gray-400"
                  >
                    -
                  </p>
                  <p
                    onClick={() => setAmount(amount + 1)}
                    className="bg-[#7349D4] text-white cursor-pointer shadow-2xl w-4 h-4 border rounded-md flex justify-center items-center shadow-gray-400"
                  >
                    +
                  </p>
                </div>
              </div>
              <div
                style={{ zIndex: 1 }}
                className="bet-bar w-[45%] bg-yellow-950 rounded-full cursor-pointer"
              >
                {betId ? (
                  <div
                    onClick={counter > 0 && handleCashOut}
                    style={{
                      background:
                        "radial-gradient(50% 50% at 50% 50%, #FF0000 0%, #A21A0A 100%)",
                    }}
                    className="flex justify-around items-center  m-2 py-2 rounded-full"
                  >
                    <p className="text-white font-semibold">
                      {counter > 0 &&
                        (
                          amount *
                          gameOptionList?.slice(0, counter).reduce((a, b) => {
                            a = a + b;
                            return a;
                          }, 0)
                        )?.toFixed(1)}
                    </p>
                    <p className="text-white font-bold font-inter text-xs">
                      Cashout
                    </p>
                  </div>
                ) : (
                  <div
                    onClick={handleApplyBet}
                    style={{
                      background:
                        "radial-gradient(50% 50% at 50% 50%, #3E7B27 0%, #118B50 100%)",
                    }}
                    className="flex justify-around items-center  m-2 py-1 md:py-2 rounded-full"
                  >
                    <p>
                      <CiPlay1 color="white" size={15} />
                    </p>
                    <p className="text-white font-bold font-inter text-xs">
                      BET
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="absolute right-0 bottom-0 flex justify-end items-center">
              <img
                src={miner}
                className="w-1/4 opacity-75 lg:opacity-100 xl:w-[45%]"
              />
            </div>
            <div className="absolute left-0 bottom-0">
              <img
                src={coinbox}
                className="w-1/4 opacity-75 lg:opacity-100 xl:w-1/2"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Mines;
